exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-automation-debugpoint[data-v-2a41207a]{height:.875rem;width:.875rem;border:1px solid var(--fts-block-danger);border-radius:50%;background-color:#fff;cursor:pointer;transition:all .3s ease-in-out}.fts-automation-debugpoint.automation-debugpoint--active[data-v-2a41207a]{background-color:rgba(var(--fts-block-danger-rgb),.25)}", ""]);

// exports
